<template>
  <div class="container">
    <div v-if="list2&&list2.length > 0">
      <div class="notification" v-for="item in list2" :key="item.msgId">
        <router-link :to="{path:'/user',query:{id:item.mainUserId}}" target="_blank">
        <img v-if="item.userImgUrl" :src="imgSiteUrl + item.userImgUrl" alt="" />
        <img v-else src="~@/assets/img/head1.png" alt="" style="background:#eee;" />
        </router-link>
        <!-- 右边部分 -->
        <div class="content">
          <!-- 第一行 -->
          <div class="fristLine">
            <div class="title">{{item.userName}}</div>
            <div class="time">{{ item.addTime }}</div>
          </div>
          <div class="lastLine" style="height:26px;">
            {{item.message}}
            <router-link v-if="item.resMap&&item.resMap.resId&&item.eventId===4" target="_blank" :to="{path:'/view/detail',query:{id:item.resMap.resId}}">《{{item.resMap.title}}》</router-link>
            <router-link v-if="item.resMap&&item.resMap.resId&&item.eventId===703" target="_blank" :to="{path:'/collection_detail',query:{id:item.resMap.resId}}">《{{item.resMap.title}}》</router-link>
          </div>
        </div>
        <hr />
      </div>
      <div class="page" v-if="page.allPage&&page.allPage>1">
          <a-pagination
              v-model:current="page.currentPage"
              :total="page.allSize"
              :show-total="total => `共 ${page.allSize} 篇`"
              :pageSize="page.pageSize"
              show-quick-jumper
              @change="changePage"
              />
      </div>
    </div>
    <div class="img" v-else>
      <img src="../../assets/img/notification.png" alt="" />
      <span style="display:block;margin-top:20px;font-size:16px">您还没有通知</span>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed,onMounted,toRefs,reactive} from "vue";
import Http from "../../until/http";
import { useRoute } from "vue-router";
import config from "../../until/configs";
export default defineComponent({
  props: {
    list2: [],
  },
    setup() {
    const imgSiteUrl = computed(() => {
      return config.imgSiteUrl;
    });
     const route = useRoute();
     const state = reactive({
      list2:[],
      page:{}
    });
    let userId = computed(() => {
      return route.query.userId;
    });

    const changePage = (e)=>{
      Http.getNotification({
          msgType: 3,
          currentPage: e,
          userId: userId.value,
        }).then((res) => {
          if (res) {
            Object.assign(state,{
              list2:res.messageEntities,
              page:res.totalPages
            });
            window.scrollTo(0,0)
          }
        });
    }

    onMounted(() => {
        Http.getNotification({
          msgType: 3,
          currentPage: 1,
          userId: userId.value,
        }).then((res) => {
          if (res) {
            state.list2 = res.messageEntities;
            state.page = res.totalPages;
          }
        });
    });
    return { imgSiteUrl ,userId, ...toRefs(state),changePage};
  },
});
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';
.container {
  width: 1200px;
  .notification {
    overflow: hidden;
    margin-top: 15px;
    img {
      float: left;
      margin-right: 10px;
      width: 49px;
      height: 49px;
      border-radius: 50%;
    }
    .content {
      margin-bottom: 18px;
      .fristLine {
        overflow: hidden;
        .title {
          float: left;
          font-size: 16px;
          color: #333;
        }
        .time {
          float: right;
          margin-right: 50px;
          font-size: 15px;
          color: #666;
        }
      }
      .lastLine{
        color: #666;
        font-size: 15px;
        a:hover {
          color:$primary-color;
        }
      }
    }
    hr {
      border: 0.5px solid #f0f0f0;
    }
  }
  .img {
    width: 120px;
    margin: 20% auto;
    text-align: center;
    img{
      width: 120px;
      margin-bottom: 10px;
    }
  }
  .page {
    text-align: center;
    padding-top: 40px;
     padding-bottom:20px;
  }
}
</style>